import type { GetStoreModulePermissionsQuery } from 'src/graphql/generated';

import { IntegrationCard } from './card-intergration';

// ----------------------------------------------------------------------

export type IntegrationConnectedFlags = {
  integratedTray: boolean;
  integratedOmie: boolean;
  integratedZekiMessage: boolean;
  integratedSMSInfobip: boolean;
  integratedBling: boolean;
  integratedDapic: boolean;
  integratedEmailProvider: boolean;
  integratedWhatsapp: boolean;
  integratedHelena: boolean;
  integratedHostgator: boolean;
  integratedShopify: boolean;
  integratedNuvemshop: boolean;
  integratedLojaIntegrada: boolean;
  integratedYampi: boolean;
  integratedTrinks: boolean;
};

type ModulePermissions = NonNullable<GetStoreModulePermissionsQuery['getStoreModulePermissions']>;

export function getAllowedIntegrationsForCardType(
  cardType: IntegrationCard,
  permissions: ModulePermissions | undefined | null
): number {
  if (!permissions) {
    return 0;
  }
  switch (cardType) {
    case IntegrationCard.COMMUNICATION:
      return permissions.hasCommunicationIntegrations ?? 0;
    case IntegrationCard.ERP:
      return permissions.hasErpIntegrations ?? 0;
    case IntegrationCard.E_COMMERCES:
      return permissions.hasEcommerceIntegrations ?? 0;
    default:
      return 0;
  }
}

export function countConnectedIntegrationsInCategory(
  cardType: IntegrationCard,
  flags: IntegrationConnectedFlags
): number {
  switch (cardType) {
    case IntegrationCard.COMMUNICATION:
      return [
        flags.integratedWhatsapp,
        flags.integratedZekiMessage,
        flags.integratedSMSInfobip,
        flags.integratedEmailProvider,
        flags.integratedHelena,
      ].filter(Boolean).length;
    case IntegrationCard.ERP:
      return [
        flags.integratedOmie,
        flags.integratedBling,
        flags.integratedDapic,
        flags.integratedTrinks,
      ].filter(Boolean).length;
    case IntegrationCard.E_COMMERCES:
      return [
        flags.integratedTray,
        flags.integratedHostgator,
        flags.integratedNuvemshop,
        flags.integratedShopify,
        flags.integratedLojaIntegrada,
        flags.integratedYampi,
      ].filter(Boolean).length;
    default:
      return 0;
  }
}

/** Quando `hasData` é true (Editar / continuar cadastro), não aplica cota. */
export function canOpenNewIntegration(
  cardType: IntegrationCard,
  hasData: boolean,
  permissions: GetStoreModulePermissionsQuery['getStoreModulePermissions'] | undefined | null,
  flags: IntegrationConnectedFlags
): boolean {
  if (hasData) {
    return true;
  }
  const allowed = getAllowedIntegrationsForCardType(cardType, permissions);
  const connected = countConnectedIntegrationsInCategory(cardType, flags);
  return connected < allowed;
}
